import { useEffect } from 'react'

import { Keys } from '@/platform/platform'
import useStore from '@/store/useStore'

export function useSwitchChannels({
  broadcastId = '',
  isActive,
}: {
  broadcastId?: string
  isActive?: boolean
}) {
  const setActiveBroadcastChannel = useStore(
    (state) => state.common.setActiveBroadcastChannel,
  )

  useEffect(() => {
    if (!isActive) {
      return
    }
    function keyPressHandler(e: KeyboardEvent) {
      const broadcast = useStore.getState().common.broadcasts?.[broadcastId]
      const isFullscreen = useStore.getState().player.isFullscreen
      const { activeChannel, channelList: channels } = broadcast || {}

      const changeChannel = (diff: number) => {
        if (!channels) {
          return
        }
        const currIndex = channels.findIndex(
          (channel: any) => channel.id === activeChannel?.id,
        )
        const nextChannel = channels[currIndex + diff]
        if (!nextChannel) {
          return
        }
        setActiveBroadcastChannel(broadcastId, nextChannel)
      }

      if (
        e.keyCode === Keys.CHANNEL_UP ||
        e.keyCode === Keys.BRACKET_RIGHT ||
        (isFullscreen && e.keyCode === Keys.ARROW_RIGHT)
      ) {
        changeChannel(1)
      }
      if (
        e.keyCode === Keys.CHANNEL_DOWN ||
        e.keyCode === Keys.BRACKET_LEFT ||
        (isFullscreen && e.keyCode === Keys.ARROW_LEFT)
      ) {
        changeChannel(-1)
      }
    }

    window.addEventListener('keydown', keyPressHandler)
    return () => {
      window.removeEventListener('keydown', keyPressHandler)
    }
  }, [broadcastId, isActive])
}
